const techKeywords = [
  "tech",
  "software",
  "online academy",
  "programming",
  "coding",
  "software development",
  "web development",
  "mobile development",
  "AI",
  "machine learning",
  "data science",
  "cybersecurity",
  "UI/UX design",
  "cloud computing",
  "full-stack development",
  "front-end development",
  "back-end development",
];

const techStackKeywords = [
  "Next.js",
  "React.js",
  "Tailwind CSS",
  "JavaScript",
  "TypeScript",
  "Python",
  "Kotlin",
  "Swift",
  "C++",
  "PHP",
  "Laravel",
  "Node.js",
  "Express.js",
  "MongoDB",
  "PostgreSQL",
  "SQL",
  "DevOps",
];

const businessKeywords = [
  "SaaS",
  "startup",
  "freelancing",
  "remote jobs",
  "SEO",
  "content marketing",
  "social media marketing",
  "digital marketing",
];

const educationKeywords = [
  "best online academy in Pakistan",
  "best online academy in Islamabad",
  "online education",
  "e-learning",
  "digital transformation",
  "IT training",
  "coding bootcamp",
  "software house",
  "best tech academy",
  "software solutions",
  "educational platform",
  "web app development",
  "mobile app development",
  "AI-powered learning",
  "online courses",
  "software engineering",
  "backend engineering",
  "frontend engineering",
  "computer science tutorials",
];

const localSeoKeywords = [
  "online courses in Pakistan",
  "IT training in Islamabad",
  "coding bootcamp in Pakistan",
  "software development courses in Pakistan",
  "best tech academy in Lahore",
  "Karachi",
  "Rawalpindi",
  "Peshawar",
  "Multan",
  "Faisalabad",
  "best software house in Islamabad",
  "freelancing training in Pakistan",
  "remote jobs in Pakistan",
  "programming courses in Pakistan",
  "best online learning platform in Pakistan",
  "web development training in Pakistan",
  "digital marketing courses in Islamabad",
  "Next.js training in Pakistan",
  "React.js courses in Pakistan",
  "AI and machine learning training in Pakistan",
  "cloud computing certification in Pakistan",
  "online education in Pakistan",
  "computer science academy in Pakistan",
  "online software engineering courses Pakistan",
  "affordable tech courses in Pakistan",
  "best online tutoring platform Pakistan",
  "software solutions Islamabad",
  "IT services Islamabad",
  "tech bootcamp Pakistan",
  "full-stack development training Pakistan",
  "Python courses in Pakistan",
  "best mobile app development training Pakistan",
];

// Combine all keywords dynamically
export const ALL_KEYWORDS_DATA = [
  ...techKeywords,
  ...techStackKeywords,
  ...businessKeywords,
  ...educationKeywords,
  ...localSeoKeywords,
].join(", ");
